<template>
  <footer class="py-2 text-xs text-center text-white bg-gradient-to-r from-[#007FCC] to-[#A55CF0]">
    &copy; {{ new Date().getFullYear() }} {{ t('allRightsReserved') }}
  </footer>
</template>
<script setup lang="ts">
const { t } = useI18n()
</script>
